// Banner IDs for various dismissable banners across the app
export const BANNER_IDS = {
  DELEGATE: 'delegate-banner-v1',
  RECOVERY: 'recoveryBanner:v0',
  LIMIT_ORDERS_INFO: 'limitOrders_showInfoBanner',
  LIMIT_ORDERS_PROTOCOL_FEE: 'limitOrders_cip74ProtocolFeeBanner',
  COW_AMM: 'cow_amm_banner_2024_va',
  ANNOUNCEMENT: 'announcementBannerClosed',
  HIRING_SPEECH_BUBBLE: 'cowHiringSpeechBubble:v0',
} as const
